import Image from "next/image";

/**
 * Official "NCCA BY ICE" accredited certification program mark.
 * Served from apps/web/public (committed asset from I.C.E. logo pack).
 */
export const NCCA_ACCREDITED_PROGRAM_MARK_SRC =
	"/exam-portal/ncca-accredited-certification-program-mark.png";

/**
 * Issued NCCA Certificate of Accreditation image (Accreditation section only).
 * Leave unset until the certificate is available.
 */
export const NCCA_CERTIFICATE_OF_ACCREDITATION_SRC: string | null = null;

type NccaAccreditedProgramMarkProps = {
	className?: string;
	/** Compact mark for inline headings; default suits the hero banner. */
	size?: "xs" | "sm" | "md" | "lg";
};

const SIZE_PX = {
	xs: 56,
	sm: 88,
	md: 120,
	lg: 152,
} as const;

/**
 * Square NCCA BY ICE accreditation mark. Use only next to CPT Certification
 * exam copy (exam portal homes, CPT programs page exam rows, and the study
 * plan exam disclaimer card) — never next to a study-plan title or course cards.
 */
const NccaAccreditedProgramMark = ({
	className,
	size = "md",
}: NccaAccreditedProgramMarkProps) => {
	const px = SIZE_PX[size];

	return (
		<div
			className={
				className ??
				"relative shrink-0 overflow-hidden rounded-md bg-white shadow-sm"
			}
			style={{ width: px, height: px }}
		>
			<Image
				src={NCCA_ACCREDITED_PROGRAM_MARK_SRC}
				alt="NCCA Accredited Certification Program mark by I.C.E."
				width={px}
				height={px}
				className="h-full w-full object-contain p-1"
			/>
		</div>
	);
};

export default NccaAccreditedProgramMark;
